/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedTime, useIntl } from 'react-intl';

import { useParseDate } from '../../hooks/useDates';
import { capitalizeFirstLetter } from '../../lib/utils';

import styles from '../../../styles/partials/date.module.scss';

const propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
    withoutTime: PropTypes.bool,
    withoutWeekday: PropTypes.bool,
    withoutYear: PropTypes.bool,
    capitalize: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    withoutTime: false,
    withoutWeekday: false,
    withoutYear: false,
    capitalize: false,
    className: null,
};

const DatePartial = ({ date, withoutTime, withoutWeekday, withoutYear, capitalize, className }) => {
    const intl = useIntl();
    if (date === null) {
        return null;
    }

    const parsedDate = useParseDate(date);
    const withTime = !withoutTime;

    const dateProps = {
        value: parsedDate,
        month: 'long',
        day: 'numeric',
    };

    if (!withoutWeekday) {
        dateProps.weekday = 'long';
    }

    if (!withoutYear) {
        dateProps.year = 'numeric';
    }

    const formattedDate = intl.formatDate(parsedDate, dateProps);
    const finalDate = capitalize ? capitalizeFirstLetter(formattedDate) : formattedDate;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {finalDate}
            {withTime ? (
                <>
                    {' - '}
                    <FormattedTime value={parsedDate} />
                </>
            ) : null}
        </div>
    );
};

DatePartial.propTypes = propTypes;
DatePartial.defaultProps = defaultProps;

export default DatePartial;
